import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { Park, Water, Waves, Grass, WaterDrop, Science } from '@mui/icons-material';

export interface ImpactArea {
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };
  title: string;
  color: string;
}

export const impactAreas: ImpactArea[] = [
  {
    icon: Park,
    title: 'Biodiversidad',
    color: '#10b981'
  },
  {
    icon: Water,
    title: 'Anti-Contaminación',
    color: '#3b82f6'
  },
  {
    icon: Waves,
    title: 'Espacios Naturales',
    color: '#06b6d4'
  },
  {
    icon: Grass,
    title: 'Prevención Erosión',
    color: '#84cc16'
  },
  {
    icon: WaterDrop,
    title: 'Medio Marino-Costero',
    color: '#0ea5e9'
  },
  {
    icon: Science,
    title: 'Calidad del Agua',
    color: '#8b5cf6'
  },
];